var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTest2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 499.97 425.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#78bfff;}.cls-3{mix-blend-mode:overlay;opacity:.2;}.cls-4{clip-path:url(#clippath-2);}.cls-5{isolation:isolate;}.cls-6{fill:#a9daff;}.cls-7{clip-path:url(#clippath-1);}.cls-8{clip-path:url(#clippath-4);}.cls-9{fill:#0a484f;}.cls-10{fill:#07353d;}.cls-11{fill:#dadada;opacity:.5;}.cls-12{clip-path:url(#clippath);}.cls-13{fill:none;}.cls-14{clip-path:url(#clippath-3);}.cls-15{mix-blend-mode:multiply;opacity:.4;}.cls-15,.cls-16{fill:#c6c6c6;}.cls-17{fill:#65a8db;}.cls-18{fill:#0f5f63;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M492.79,300.72c-.02-5.94-.57-11.96-1.68-17.8-4.43-23.31-16.04-42.48-34.57-57.27-17.23-13.74-36.99-20.78-59.07-20.81-50.19-.08-100.38-.02-150.56-.04-1.73,0-3.48-.09-5.17-.4-12.3-2.27-20.68-12.41-20.68-24.95,0-27.97,.01-55.94-.02-83.91,0-3.09-.17-6.2-.51-9.28-2.26-20.45-10.62-38.1-25.13-52.63-17.34-17.38-38.47-26.17-63.04-26.23-38.28-.1-76.56-.03-114.84-.03h-1.54V74.71h24.27c30.52,0,61.05,.09,91.57-.04,13.4-.06,22.07,10.72,21.97,21.9-.26,27.6-.16,55.21-.02,82.81,.03,5.45,.42,10.97,1.4,16.32,4.86,26.49,18.72,47.17,41.25,61.88,15.17,9.91,32.01,14.57,50.09,14.58,30.43,.02,60.85,.02,91.28,.02l-1.88-6.99,8.29-6.84-4.14-3.24,6.3-6.84-6.48-11.16,6.48-16.94-3.24,16.94,9.73,11.88-5.4,5.76,5.4,4.68-4.2,6.36,5.04,6.39c16.75,0,26.93,0,43.67-.01,3.14,0,6.17,.53,9.11,1.58,11.64,4.15,19.05,14.81,19.05,27.45,0,37.37,0,74.74,0,112.1,0,.57,0,1.15,0,1.75h67.35v-1.53c0-37.6,.07-75.19-.08-112.79Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "23.55 81.55 3.23 81.55 0 77.79 0 3.76 2.83 0 23.42 0 26.38 4.03 26.38 78.32 23.55 81.55"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "273.55 278.24 253.23 278.24 249.99 274.47 249.99 200.44 252.82 196.68 273.41 196.68 276.38 200.71 276.38 275.01 273.55 278.24"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "227.66 116.41 227.66 136.73 223.89 139.96 149.86 139.96 146.1 137.14 146.1 116.54 150.13 113.58 224.43 113.58 227.66 116.41"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "499.97 402.02 499.97 422.34 496.2 425.57 422.17 425.57 418.41 422.74 418.41 402.15 422.44 399.19 496.74 399.19 499.97 402.02"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M492.86,415.04h-67.35c0-.6,0-1.18,0-1.75,0-37.37,0-74.74,0-112.1,0-12.64-7.41-23.3-19.05-27.45-2.94-1.05-5.97-1.58-9.11-1.58-50.28,.01-100.56,.03-150.84,0-18.09-.01-34.92-4.67-50.09-14.58-22.53-14.72-36.38-35.39-41.25-61.88-.98-5.35-1.38-10.87-1.4-16.32-.14-27.6-.24-55.21,.02-82.81,.11-11.18-8.57-21.96-21.97-21.9-30.52,.14-61.05,.04-91.57,.04H15.97V7.38h1.53c38.28,0,76.56-.07,114.84,.03,24.57,.06,45.7,8.85,63.04,26.23,14.5,14.54,22.86,32.18,25.13,52.63,.34,3.07,.5,6.18,.51,9.28,.04,27.97,.02,55.94,.02,83.91,0,12.54,8.38,22.67,20.68,24.95,1.69,.31,3.45,.4,5.17,.4,50.19,.02,100.38-.04,150.56,.04,22.08,.03,41.84,7.07,59.07,20.81,18.54,14.79,30.14,33.96,34.57,57.27,1.11,5.83,1.66,11.86,1.68,17.8,.15,37.6,.07,75.19,.08,112.79v1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M491.1,282.93c-4.43-23.31-16.04-42.48-34.57-57.27-17.23-13.74-36.99-20.78-59.07-20.81-50.19-.08-100.38-.02-150.56-.04-1.73,0-3.48-.09-5.17-.4-12.3-2.27-20.68-12.41-20.68-24.95,0-27.97,.01-55.94-.02-83.91,0-3.09-.17-6.2-.51-9.28-2.26-20.45-10.62-38.1-25.13-52.63-17.34-17.38-38.47-26.17-63.04-26.23-38.28-.1-76.56-.03-114.84-.03h-1.54v29.27h113.77c48.73,0,72.07,14.2,72.07,72.07v69.59c0,30.39,24.63,55.02,55.02,55.02h149.66c41.37,0,57.64,25,57.64,57.42v124.29h28.73v-1.53c0-37.6,.07-75.19-.08-112.79-.02-5.94-.57-11.96-1.68-17.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M21.42,74.71h18.37V7.37c-6.12,0-12.25,0-18.37,0V74.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M447.46,390.96c0-37.37,0-54.55,0-91.92,0-20.8-4.86-48.63-45.46-48.63-3.12,0-28.92-.58-32.06-.58-50.28,.01-51.21,.03-101.49,0-18.09-.01-34.92-4.67-50.09-14.58-22.53-14.72-36.38-35.39-41.25-61.88-.98-5.35-1.38-10.87-1.4-16.32-.14-27.6,.02-37.16,.02-64.77s-7.88-39.94-46.41-39.94c-30.52,0-36.61,.04-67.13,.04H15.97v22.33h24.27c30.52,0,61.05,.09,91.57-.04,13.4-.06,22.07,10.72,21.97,21.9-.26,27.6-.16,55.21-.02,82.81,.03,5.45,.42,10.97,1.4,16.32,4.86,26.49,18.72,47.17,41.25,61.88,15.17,9.91,32.01,14.57,50.09,14.58,50.28,.04,100.56,.02,150.84,0,3.14,0,6.17,.53,9.11,1.58,11.64,4.15,19.05,14.81,19.05,27.45,0,37.37,0,74.74,0,112.1,0,.57,0,1.15,0,1.75h21.95v-24.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M221.04,128.66h-67.41c-.01,9.85,0,19.69,.03,29.54h67.38c0-9.85,0-19.69,0-29.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M234.67,271.44c3.88,.47,7.82,.71,11.83,.71,3.84,0,7.69,0,11.53,0v-67.36c-3.71,0-7.42,0-11.13,0-1.73,0-3.48-.09-5.17-.4-2.54-.47-4.89-1.29-7.06-2.38v69.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M492.87,383.33h-67.36c0,9.99,0,19.97,0,29.96,0,.57,0,1.15,0,1.75h67.35v-1.53c0-10.06,0-20.12,0-30.18Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "110 70.31 103.49 7.37 96.04 7.37 96.05 7.35 88.84 7.35 85.54 7.35 81.22 7.35 81.22 7.35 79.92 7.35 76.48 7.35 74.79 7.35 74.79 7.35 66.11 7.35 60.99 7.35 60.99 7.35 62.91 74.71 62.91 74.71 66.93 74.71 66.87 74.98 81.46 74.98 81.46 74.98 94.46 74.74 110.46 74.71 110 70.31"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "23.55 81.55 3.23 81.55 0 77.79 0 3.76 2.83 0 23.42 0 26.38 4.03 26.38 78.32 23.55 81.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "26.38 4.03 23.42 0 11.31 0 11.31 69.53 14.54 73.3 26.38 73.3 26.38 4.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "10.05 76.17 6.82 72.4 6.82 0 2.83 0 0 3.76 0 77.79 3.23 81.55 23.55 81.55 26.38 78.32 26.38 76.17 10.05 76.17"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.9,
    y: -13.2,
    width: 10.36,
    height: 47.51,
    transform: "translate(13.68 -2.59) rotate(60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.09,
    y: 5.18,
    width: 3.68,
    height: 47.51,
    transform: "translate(32.03 2.4) rotate(60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.19,
    y: 43.2,
    width: 3.68,
    height: 47.51,
    transform: "translate(66.5 18.73) rotate(60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.5,
    y: 28.8,
    width: 13.64,
    height: 47.51,
    transform: "translate(52.68 13.88) rotate(60)"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "273.55 278.24 253.23 278.24 249.99 274.47 249.99 200.44 252.82 196.68 273.41 196.68 276.38 200.71 276.38 275.01 273.55 278.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "276.38 200.71 273.41 196.68 261.3 196.68 261.3 266.21 264.53 269.98 276.38 269.98 276.38 200.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "260.04 272.85 256.81 269.08 256.81 196.68 252.82 196.68 249.99 200.44 249.99 274.47 253.23 278.24 273.55 278.24 276.38 275.01 276.38 272.85 260.04 272.85"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 253.9,
    y: 183.48,
    width: 10.36,
    height: 47.51,
    transform: "translate(309.01 -120.75) rotate(60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 262.09,
    y: 201.86,
    width: 3.68,
    height: 47.51,
    transform: "translate(327.35 -115.76) rotate(60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 265.18,
    y: 239.88,
    width: 3.68,
    height: 47.51,
    transform: "translate(361.82 -99.43) rotate(60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 257.5,
    y: 225.48,
    width: 13.64,
    height: 47.51,
    transform: "translate(348.01 -104.28) rotate(60)"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "146.1 116.41 146.1 136.73 149.87 139.96 223.9 139.96 227.66 137.13 227.66 116.54 223.63 113.58 149.33 113.58 146.1 116.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "223.63 113.58 227.66 116.54 227.66 128.66 158.13 128.66 154.36 125.42 154.36 113.58 223.63 113.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "151.48 129.91 155.25 133.14 227.66 133.14 227.66 137.13 223.9 139.96 149.87 139.96 146.1 136.73 146.1 116.41 149.33 113.58 151.48 113.58 151.48 129.91"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 204.48,
    y: 93.01,
    width: 10.36,
    height: 81.58,
    transform: "translate(299.38 365.76) rotate(-143.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 189.27,
    y: 97.94,
    width: 5.29,
    height: 58.04,
    transform: "translate(271.39 342.91) rotate(-143.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.63,
    y: 95.95,
    width: 3.68,
    height: 47.51,
    transform: "translate(208.07 307.64) rotate(-143.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 161.67,
    y: 93.76,
    width: 13.64,
    height: 60.43,
    transform: "translate(230.85 323.65) rotate(-143.69)"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "418.41 402.02 418.41 422.34 422.18 425.57 496.21 425.57 499.97 422.74 499.97 402.15 495.94 399.19 421.64 399.19 418.41 402.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "495.94 399.19 499.97 402.15 499.97 414.26 430.44 414.26 426.67 411.03 426.67 399.19 495.94 399.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "423.8 415.52 427.57 418.75 499.97 418.75 499.97 422.74 496.21 425.57 422.18 425.57 418.41 422.34 418.41 402.02 421.64 399.19 423.8 399.19 423.8 415.52"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 476.79,
    y: 378.62,
    width: 10.36,
    height: 81.58,
    transform: "translate(622.02 1042.77) rotate(-143.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 461.58,
    y: 383.55,
    width: 5.29,
    height: 58.04,
    transform: "translate(594.03 1019.92) rotate(-143.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 424.94,
    y: 381.56,
    width: 3.68,
    height: 47.51,
    transform: "translate(530.69 984.65) rotate(-143.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 433.98,
    y: 379.37,
    width: 13.64,
    height: 60.43,
    transform: "translate(553.48 1000.66) rotate(-143.69)"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M359.85,381.04c0-9.98-14.49-18.6-14.49-33.87,0,15.27-14.49,23.89-14.49,33.87s6.49,18.07,14.49,18.07,14.49-8.09,14.49-18.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M350.33,393.88c-6.68,0-12.1-7.28-12.1-16.25,0-6.34,6.03-12.07,9.58-19.72-1.46-3.22-2.45-6.75-2.45-10.73,0,15.27-14.49,23.89-14.49,33.87s6.49,18.07,14.49,18.07c5.21,0,9.77-3.45,12.32-8.6-2.04,2.1-4.58,3.36-7.35,3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M344.18,379.53c0,6.76,5.48,12.25,12.25,12.25,.2,0,.39-.02,.59-.03,1.77-3,2.83-6.69,2.83-10.7,0-4.51-2.96-8.74-6.2-13.43-5.42,1.26-9.47,6.11-9.47,11.92Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M352.01,309.67c0-4.58-6.65-8.54-6.65-15.55,0,7.01-6.65,10.97-6.65,15.55s2.98,8.3,6.65,8.3,6.65-3.72,6.65-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M347.64,315.56c-3.07,0-5.56-3.34-5.56-7.46,0-2.91,2.77-5.54,4.4-9.06-.67-1.48-1.12-3.1-1.12-4.93,0,7.01-6.65,10.97-6.65,15.55s2.98,8.3,6.65,8.3c2.39,0,4.49-1.58,5.66-3.95-.94,.96-2.1,1.54-3.37,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M344.82,308.97c0,3.11,2.52,5.62,5.62,5.62,.09,0,.18,0,.27-.01,.81-1.38,1.3-3.07,1.3-4.92,0-2.07-1.36-4.01-2.85-6.17-2.49,.58-4.35,2.81-4.35,5.47Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest2);
export default __webpack_public_path__ + "static/media/test2.04f98b2e334057547f71c0076c847414.svg";
export { ForwardRef as ReactComponent };